import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Feedstock } from '../../../../../models/project/feedstock/feedstock.model';
import { MaterialService } from '../../../material.service';
import { NgForm } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../../../helper/translation/anessa-translation.service';
import { FeedstockMaterial } from '../../../../../models/data-structures/materials/materials-data.model';
import { UserpilotReloader } from '../../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-feedstock-quantities',
  templateUrl: './feedstock-quantities.component.html',
  styleUrls: ['./feedstock-quantities.component.scss']
})
export class FeedstockQuantitiesComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  @ViewChild('quantitiesForm') quantitiesForm: NgForm;
  /** The current feedstock instance */
  @Input() feedstock: Feedstock;
  /** A notifier that is emits <null> when a change is made to the current feedstock */
  @Output() changesMadeNotifier = new EventEmitter();
  @Output() formIsValid = new EventEmitter<boolean>();
  /** a flag that signifies is a material is selected */
  materialNotSelected = true;
  /** trigger for translation pipe */
  trigger: string;

  constructor(private materialService: MaterialService,
    public translationService: AnessaTranslationService) {
    super();
  }

  ngOnInit(): void {
    this.translationService.languageChangeNotifier
    .pipe(takeUntil(this.onDestroyNotifier))
    .subscribe(() => {
      this.trigger = this.translationService.getCurrentLang();
    });
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  /**
   * triggers the changes made notifier
   */
  onUnitValueChanged() {
    this.formIsValid.emit(this.quantitiesForm.form.valid);
    this.changesMadeNotifier.emit();
  }

  /**
   * returns a true or false depending on if the the currently selected material is animal or not
   */
  materialTypeIsAnimal() {
    if (this.feedstock) {
      let material: FeedstockMaterial;
      if (this.feedstock.materialId) {
        material = this.materialService.getMaterialById(this.feedstock.materialId);
      } else if (this.feedstock.category === 'unknown') {
        material = FeedstockMaterial.getUnknownDisplayMaterial();
      } else if (this.feedstock.category && this.feedstock.type && this.feedstock.source) {
        material = this.materialService.getMaterialByValues(this.feedstock.category, this.feedstock.type, this.feedstock.source);
      }
      if (material) {
        this.materialNotSelected = false;
        return material.isAnimal;
      }
    }
    this.materialNotSelected = true;
    return false;
  }
}
